import * as THREE from 'three';

const HIDDEN = new THREE.Matrix4().makeScale(0, 0, 0);

/**
 * Reserva fija de instancias de una misma malla (una sola llamada de dibujo).
 * El camino infinito pide y devuelve instancias en lugar de crear/destruir mallas,
 * así no hay asignaciones en GPU ni basura durante la partida.
 */
export class InstancePool {
  constructor(name, geometry, material, capacity, { colors = false, dynamic = false } = {}) {
    const mesh = new THREE.InstancedMesh(geometry, material, capacity);
    mesh.name = name;
    // Las instancias se reparten por todo el mapa: el volumen global no sirve para descartar.
    mesh.frustumCulled = false;
    if (dynamic) mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
    if (colors) mesh.instanceColor = new THREE.InstancedBufferAttribute(new Float32Array(capacity * 3).fill(1), 3);
    for (let i = 0; i < capacity; i++) mesh.setMatrixAt(i, HIDDEN);
    this.mesh = mesh;
    this.capacity = capacity;
    this.freeList = Array.from({ length: capacity }, (_, i) => capacity - 1 - i);
  }

  get used() {
    return this.capacity - this.freeList.length;
  }

  /** Devuelve el índice reservado, o -1 si la reserva está llena. */
  alloc(matrix, color) {
    const i = this.freeList.pop();
    if (i === undefined) {
      console.warn(`[InstancePool] "${this.mesh.name}" sin instancias libres (${this.capacity})`);
      return -1;
    }
    this.mesh.setMatrixAt(i, matrix);
    this.mesh.instanceMatrix.needsUpdate = true;
    if (color && this.mesh.instanceColor) {
      this.mesh.setColorAt(i, color);
      this.mesh.instanceColor.needsUpdate = true;
    }
    return i;
  }

  setMatrix(i, matrix) {
    this.mesh.setMatrixAt(i, matrix);
    this.mesh.instanceMatrix.needsUpdate = true;
  }

  release(i) {
    if (i < 0) return;
    this.mesh.setMatrixAt(i, HIDDEN);
    this.mesh.instanceMatrix.needsUpdate = true;
    this.freeList.push(i);
  }
}
